import styled from 'styled-components';

import { BaseStyle, Select } from '@nhl/nhl-breakaway-ui';

const STANDARD_PADDING_OFFSET = '32px';
const SMALL_BADGE_SIZE = 80;
const LARGE_BADGE_SIZE = 96;

export const PlayerNameSelectContainer = styled.div<{ $isModern?: boolean }>`
    background: none;
    display: flex;
    flex-direction: column;
    margin-top: ${({ $isModern }) => ($isModern ? '12px' : 0)};
    padding: 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-top: ${({ $isModern }) => ($isModern ? '24px' : 0)};
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        background: ${({ theme }) => theme.Surface.primary};
        flex-direction: row;
        justify-content: space-between;
        padding: 0 27px 24px 0;
    }

    h1 {
        align-self: center;
    }
`;

export const PlayerNameSelectHalfContainer = styled.div`
    display: flex;
    flex-direction: row;

    h1,
    .team-display-container {
        padding: 0 12px;
        border-right: 1px solid ${({ theme }) => theme.Surface.border};
    }

    h1:last-child {
        border-right: none;
    }
`;

export const PlayerDetailsRow = styled.div`
    align-items: center;
    align-self: center;
    display: flex;
    flex-direction: row;
    padding: 12px 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding: initial;
    }

    .logo {
        padding-right: 8px;
    }
`;

export const PlayerHeader = styled.h5`
    align-items: center;
    border-left: 1px solid ${({ theme }) => theme.Surface.border};
    display: flex;
    justify-content: center;
    height: 24px;
    width: 56px;
`;

export const SweaterHeader = styled(PlayerHeader)<{ $teamLogo?: string }>`
    border-left: ${({ $teamLogo }) => ($teamLogo ? `1px solid ${({ theme }) => theme.Surface.border};` : 'initial')};
`;

export const PlayerInfoMediumWidthContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const MediumWidthContainerVerticalDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MediumWidthContainerLeftDiv = styled(MediumWidthContainerVerticalDiv)`
    width: 160px;

    .headshot-container {
        top: -12px;
    }

    .socials {
        align-self: center;
    }
`;

export const MediumWidthContainerRightDiv = styled(MediumWidthContainerVerticalDiv)`
    padding-left: 32px;
    width: 100%;

    div {
        align-self: flex-start;
    }
`;

export const PlayerHeaderImage = styled.div<{ $imageUrl: string }>`
    background-image: url(${({ $imageUrl }) => $imageUrl});

    width: calc(100vw + 48px); // so that image overflows PageWrapper padding
    height: calc(56.25vw + 27px); // 9/16ths of 100vw + 48px width
    background-size: cover;
    margin-left: -24px;
    background-position: center; // the Mad Max Fury Road principle: assume the action is going to be in the center of the frame

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 636px;
        max-width: 1296px;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        width: calc(100vw + 32px);
        margin-left: -16px;
        height: 212px;
        background-size: cover;
    }
`;

export const BackgroundBlurContainer = styled.div`
    display: flex;
    position: relative;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
    flex-direction: column;

    .headshot-container {
        align-self: center;
        ${BaseStyle.Mixins.screenSizes.medium} {
            top: -25px;
        }
        top: -115px;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        border-bottom: none;
        flex-direction: row;
    }

    height: 228px; // 4px extra to insure against overlap
    top: 414px;
    width: calc(100% - ${STANDARD_PADDING_OFFSET});
    padding: 22px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(8px);

    ${BaseStyle.Mixins.screenSizes.large} {
        width: 100%;
        background: rgba(255, 255, 255, 0.8);
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        height: 283px;
        top: 212px;
    }
`;

export const SmallBackgroundContainer = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
    flex-direction: column;
    // Moving the centered container left by 16px so this border takes up the full width
    margin-left: -16px;
    width: 100vw;

    .headshot-container {
        align-self: center;
        margin-top: -90px;
    }
`;

export const HeadshotBirthplaceContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
`;

export const SmallBadgeContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 16px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-bottom: initial;
    }

    img {
        margin: 0 8px;
    }
`;

export const LargeBadgeContainer = styled.div`
    display: flex;
    justify-content: end;
    position: relative;
    // Move the container up by the size of the badges so the elements below show in the correct positioning
    // Then move the container to the correct spot by using top
    margin-top: -${LARGE_BADGE_SIZE}px;
    top: -206px;
    width: 100%;

    img {
        margin: 0 8px;
    }
`;

export const PlayerBadge = styled.img<{ $isSmall?: boolean }>`
    height: ${({ $isSmall }) => ($isSmall ? `${SMALL_BADGE_SIZE}px` : `${LARGE_BADGE_SIZE}px`)};
    width: ${({ $isSmall }) => ($isSmall ? `${SMALL_BADGE_SIZE}px` : `${LARGE_BADGE_SIZE}px`)};
`;

export const StyledSelect = styled(Select)`
    height: 44px;
    margin-left: 12px;
`;

export const SmallGrayText = styled.label`
    ${BaseStyle.Mixins.fontStyles.ui['12mCaps']}
    line-height: 100%;
    text-transform: uppercase;
    color: ${({ theme }) => theme.Text.secondary};
    margin: auto;
`;
